import React, { FunctionComponent } from 'react';
import SingleCurrencyCash from '../../../presentational/prices/singleCurrency/cash/SingleCurrencyCash';
import MultiCurrencyCashContainer from './multiCurrency/cash/MultiCurrencyCashContainer';
import IPrice from '../../../../../gqlCommon/model/prices/IPrice';
import SingleCurrency from '../../../presentational/prices/singleCurrency/finance/SingleCurrency';
import { IPriceDisplay } from '../../../../../common/model/IPlatformConfig';
import { IFinanceData } from '../../../../../gqlCommon/model/IFinanceData';
import { FinanceResultType } from '../../../../../__generated__/globalTypes';
import FinancePriceDisplayMulti from '../../../presentational/prices/multiCurrency/finance/FinancePriceDisplayMulti';
import useMoney from '../../../../../gqlCommon/hooks/prices/useMoney';
import { GetCustomizeCar_customizeCar_stockInfo } from '../../../../graphql/queries/__generated__/GetCustomizeCar';

export interface IFinanceProductSectionProps {
  loading?: boolean;
  primaryPrice: IPrice;
  secondaryPrice: IPrice;
  onDriveawayIndicativeClick: () => void;
  isMultiCurrency: boolean;
  finance?: IFinanceData;
  isCash: boolean;
  onFinanceCalculate: () => void;
  priceDisplay: IPriceDisplay;
  taxLabel?: string;
  stockInfo: GetCustomizeCar_customizeCar_stockInfo;
}

const PriceSection: FunctionComponent<IFinanceProductSectionProps> = ({
  loading,
  onDriveawayIndicativeClick,
  isMultiCurrency,
  finance,
  primaryPrice,
  secondaryPrice,
  onFinanceCalculate,
  taxLabel,
  stockInfo,
}) => {
  const isCashProduct = !finance || (finance && finance.type === FinanceResultType.cash);

  const { primaryPrice: primaryPriceFinance, secondaryPrice: secondaryPriceFinance } = useMoney(
    finance?.simulation?.paymentValue,
  );

  if (isMultiCurrency && isCashProduct) {
    return (
      <MultiCurrencyCashContainer
        isLoading={loading}
        primaryPrice={primaryPrice}
        secondaryPrice={secondaryPrice}
        onIndicativeClick={onDriveawayIndicativeClick}
      />
    );
  }

  if (!isMultiCurrency && isCashProduct) {
    return (
      <SingleCurrencyCash
        loading={loading}
        primaryPrice={primaryPrice}
        onIndicativeClick={onDriveawayIndicativeClick}
        taxLabel={taxLabel}
        stockInfo={stockInfo}
      />
    );
  }

  if (isMultiCurrency && !isCashProduct) {
    return (
      <FinancePriceDisplayMulti
        primaryPrice={primaryPriceFinance}
        secondaryPrice={secondaryPriceFinance}
        onFinanceCalculate={onFinanceCalculate}
        onIndicativeClick={onDriveawayIndicativeClick}
      />
    );
  }

  return (
    <SingleCurrency
      loading={loading}
      paymentValue={primaryPriceFinance}
      comparisonRate={finance?.simulation?.comparisonRate}
      paymentFrequency={finance?.simulation?.frequency}
      onFinanceCalculate={onFinanceCalculate}
      taxLabel={taxLabel}
    />
  );
};

export default PriceSection;
